import { render, staticRenderFns } from "./bindTemplateStore.vue?vue&type=template&id=6554461f&"
import script from "./bindTemplateStore.vue?vue&type=script&lang=js&"
export * from "./bindTemplateStore.vue?vue&type=script&lang=js&"
import style0 from "./bindTemplateStore.vue?vue&type=style&index=0&id=6554461f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports